export enum PropertyStatuses {
  IMPORTED = 'IMPORTED',
  RESERVED = 'RESERVED',
  DEFAULT = 'DEFAULT',
  RENTED = 'RENTED',
  EXTERNAL = 'EXTERNAL'
}
